import React from 'react';
import { Provider } from 'models';
import { Grid, TextField, makeStyles } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';

interface IProps {
    provider: Provider;
    message: string;
    setMessage: (s: string) => void;
    onClick: () => void;
}

const useStyles = makeStyles(() => ({
    noBorder: {
        border: 'none',
    },
}));

export default function MessageForm({ message, setMessage, onClick, provider }: IProps) {
    const classes = useStyles();

    return (
        <Grid container item>
            <Grid item xs={12}>
                <Grid
                    container
                    style={{
                        paddingRight: 15,
                        paddingLeft: 15,
                        borderTopWidth: 0.5,
                        borderTopColor: 'gray',
                        borderTopStyle: 'solid',
                        alignItems: 'center',
                        maxHeight: 100,
                    }}
                >
                    <Grid item style={{ flexGrow: 1, maxHeight: 100, overflow: 'scroll' }}>
                        <TextField
                            variant="outlined"
                            style={{ width: '100%', outline: 'none' }}
                            placeholder={`Message ${provider.user.first_name} here...`}
                            InputProps={{
                                classes: { notchedOutline: classes.noBorder },
                            }}
                            multiline
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <SendIcon
                            color={message.length > 0 ? 'primary' : 'disabled'}
                            style={{ cursor: 'pointer' }}
                            onClick={onClick}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
